import { gql } from '@apollo/client';

export const getAllPromoCode = gql`query getAllPromoCode($currentPage: Int, $searchKey: String) {
    getAllPromoCode(currentPage: $currentPage, searchKey: $searchKey) {
        status
        errorMessage
        count
        results {
          id
          title
          description
          code
          promoValue
          expiryDate
          isEnable
		      isPrivate
          createdAt
          updatedAt
          deductionType
          dynamicPromoCode {
            id
            codeId
            language
            title
            description
        }
        }
    }
}`;

export const updatePromoStatus = gql`
mutation updatePromoStatus($id: Int!, $isEnable: Boolean){
  updatePromoStatus(id: $id, isEnable: $isEnable){
      status
      errorMessage
  }
}`;

export const getPromoCode = gql`query getPromoCode($id: Int!) {
  getPromoCode(id: $id) {
      status
      errorMessage
      result {
        id
        title
        description
        code
        promoValue
        expiryDate
        isEnable
        isPrivate
        createdAt
        updatedAt
        deductionType
        dynamicPromoCode {
        id
        codeId
        language
        title
        description
        }
      }
  }
}`;

export const updatePromoCode = gql`
mutation updatePromoCode( 
  $id: Int,
  $title: String!, 
  $code: String!, 
  $promoValue: Float!, 
  $expiryDate: String,
  $isEnable: Boolean,
  $deductionType: String,
  $description:String,
  $dynamicPromoCode:String
) {
  updatePromoCode(
      id: $id,
      title: $title,
      code: $code,
      promoValue: $promoValue,
      expiryDate: $expiryDate,
      isEnable: $isEnable,
      deductionType: $deductionType,
      description:$description,
      dynamicPromoCode:$dynamicPromoCode
  ) {
      status
      errorMessage
  }
}`;

export const deletePromoCode = gql`
mutation deletePromoCode($id: Int!){
  deletePromoCode(id: $id){
      status
      errorMessage
  }
}`;

export const validatePromoCode = gql`
query validatePromoCode($code: String!){
  validatePromoCode(code: $code){
      status
      errorMessage
      result{
       id
       code
       promoValue
       deductionType
       description
       dynamicPromoCode {
        id
        codeId
        language
        title
        description
        }
      }
  }
}`;